import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { detailSearchParams } from '@@components/Page/detailSearchParams';
import { loadContentDetail } from '@@components/Page/loadContentDetail';
import { placementHistorySearchParams } from '@@containers/placementHistory/placementHistorySearchParams';

import { LinkDetailPage } from '../-components/LinkDetailPage';

export const Route = createFileRoute('/_authenticated/externalContent/links/$id')({
    validateSearch: detailSearchParams.extend(placementHistorySearchParams.shape),
    context: ({ params }) => ({
        contentQuery: client.externalContent.link.get.queryOptions({ params: { id: params.id } }),
    }),
    loader: ({ abortController, context, params }) =>
        loadContentDetail({ ...context, abortController }, params.id),
    component: LinkDetailPage,
});
